export const formatConditionGroup = item => {
  if (item.conditionGroup1?.includes("C1")) {
    return "C1 - Container 20'";
  } else if (item.conditionGroup1?.includes("C2")) {
    return "C2 - Container 40'";
  } else if (item.conditionGroup1?.includes("C3")) {
    return "C3 - Container 40' H";
  } else {
    return item.conditionGroup1;
  }
};

export const formatRouteTitle = ({ routeId = "", routeName = "" }) =>
  [routeId, routeName].filter(val => val).join("-");
